import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import HomeIcon from '../../../icons/HomeIcon'
import ProfileIcon from '../../../icons/ProfileIcon'
import { PRIVATE_ROUTES } from '../../../Routes/routes'
import SidebarButton from './SidebarButton'
import { typeUser } from '../../../localStorage'
import { IS_TALENT, TYPE_OF_USER, VIEWPORT_LG } from '../../../utils/constants'
import SmallBriefcaseIcon from '../../../icons/SmallBriefcaseIcon'
import SearchUserIcon from '../../../icons/SearchUserIcon'
import HandsIcon from '../../../icons/HandsIcon'
import { useTranslation } from 'react-i18next'
import UserSearchIcon from '../../../icons/UserSearchIcon'
import BriefcaseIcon from '../../../icons/BriefcaseIcon'
import HouseAndBuildingIcon from '../../../icons/HouseAndBuildingIcon'
import ConfigIcon from '../../../icons/ConfigIcon'
import EmailCheckedIcon from '../../../icons/EmailCheckedIcon'
import NoteIcon from '../../../icons/NoteIcon'
import useResize from '../../../hooks/useResize'
import AwasomeIcon from '../../../icons/AwasomeIcon'
import Badge from '../../Badge/Badge'
import WhatsAppChatIcon from '../../../icons/WhatsAppChatIcon'
import { getTalentContract } from '../../../services/NewServicesTalent'
import { TAGS } from '../../../services/Tags'
import VideoCameraIcon from '../../../icons/VideoCameraIcon'
import CalendarIcon from '../../../icons/CalendarIcon'
import GraduationCapIcon from '../../../icons/GraduationCapIcon'

const Menu = ({ userData = {}, setOpenDrawer }) => {
  const navigate = useNavigate()
  const { userInfo: profileUserInfo = {} } = userData
  const { steps_completed = false } = profileUserInfo || {}
  const { t } = useTranslation()
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG
  const renderHutritNextValidation = IS_TALENT
    ? profileUserInfo?.hutrit_next
    : true

  const { data: talentContractData } = useQuery({
    queryKey: [TAGS.talent_contract],
    queryFn: getTalentContract,
    enabled: IS_TALENT,
  })

  const hasTalentContract = Boolean(talentContractData?.res?.contract)

  const handleGoToPersonalTalentInformation = () => {
    steps_completed
      ? navigate(PRIVATE_ROUTES.update_personal_information)
      : navigate(PRIVATE_ROUTES.talent_information)
  }

  const handleGoToProfessionalTalentInformation = () => {
    steps_completed
      ? navigate(PRIVATE_ROUTES.update_professional_information)
      : navigate(PRIVATE_ROUTES.talent_information)
  }

  const handleCloseDrawer = () => {
    if (!isMobile) return
    setOpenDrawer(false)
  }

  const TalentRoutes = () => (
    <>
      <div className="dropdown">
        <SidebarButton
          data-bs-toggle="collapse"
          href="#sidebar-collapse"
          Icon={() => <ProfileIcon width="16" height="16" />}
          title={t('my_profile')}
          className="mb-2"
          role="button"
          onClick={() => {}}
        />
        <div
          className="collapse show"
          id="sidebar-collapse"
          aria-expanded="true"
        >
          <SidebarButton
            className="sidebar-button-inside w-75"
            titleClassName="ms-2"
            title={t('staff')}
            onClick={() => {
              handleCloseDrawer()
              handleGoToPersonalTalentInformation()
            }}
          />
          <SidebarButton
            className="sidebar-button-inside w-75"
            titleClassName="ms-2"
            title={t('professional')}
            onClick={() => {
              handleCloseDrawer()
              handleGoToProfessionalTalentInformation()
            }}
          />
        </div>
      </div>
      <div className="dropdown">
        <SidebarButton
          href="#sidebar-collapse-challenge-hutrit-club"
          onClick={() => navigate('/hutrit-club-upload-video')}
          Icon={() => <VideoCameraIcon width="16" height="16" />}
          title="Hutrit Club"
        />
      </div>
      <div className="dropdown">
        <SidebarButton
          onClick={() => {
            handleCloseDrawer()
            navigate(PRIVATE_ROUTES.masterClass)
          }}
          Icon={() => <CalendarIcon fill="#E4F8ED" width="16" height="16" />}
          title={
            <div className="d-flex align-items-center">
              <div>Master class</div>
              <Badge
                style={{
                  background: '#CFF2DF',
                  border: '1px solid #01A76A',
                  color: '#01A76A',
                  padding: '6px 8px 6px 8px',
                  borderRadius: '12px',
                  marginLeft: '8px',
                }}
              >
                {t('new')}
              </Badge>
            </div>
          }
        />
      </div>
      <div className="dropdown">
        <SidebarButton
          onClick={() => {
            handleCloseDrawer()
            navigate(PRIVATE_ROUTES.academy)
          }}
          Icon={() => <GraduationCapIcon width="16" height="16" />}
          title={
            <div className="d-flex align-items-center">
              <div>Academia Hutrit</div>
              <Badge
                style={{
                  background: '#CFF2DF',
                  border: '1px solid #01A76A',
                  color: '#01A76A',
                  padding: '6px 8px 6px 8px',
                  borderRadius: '12px',
                  marginLeft: '8px',
                }}
              >
                Nuevo
              </Badge>
            </div>
          }
        />
      </div>
      {hasTalentContract && (
        <SidebarButton
          Icon={() => <NoteIcon fill="#E4F8ED" width="16" height="16" />}
          className="mb-2"
          title="Contrato"
          onClick={() => {
            handleCloseDrawer()
            navigate(PRIVATE_ROUTES.talent_contract)
          }}
        />
      )}
    </>
  )

  const RecruiterRoutes = () => (
    <>
      <SidebarButton
        title={t('my_profile')}
        onClick={() => {
          handleCloseDrawer()
          navigate(PRIVATE_ROUTES.personal_data)
        }}
        Icon={() => <ProfileIcon width="16" height="16" />}
        className="mb-2"
      />
      <SidebarButton
        className="mb-2"
        title={t('my_talents')}
        onClick={() => {
          handleCloseDrawer()
          navigate(PRIVATE_ROUTES.tm_talents)
        }}
        Icon={() => <UserSearchIcon />}
      />
      <div className="dropdown mb-2">
        <SidebarButton
          data-bs-toggle="collapse"
          href="#sidebar-collapse"
          Icon={() => <BriefcaseIcon width="16" height="16" />}
          title={t('offers')}
          className="mb-2"
          role="button"
          onClick={() => {}}
        />
        <div
          className="collapse show"
          id="sidebar-collapse"
          aria-expanded="true"
        >
          <SidebarButton
            className="sidebar-button-inside w-75"
            title={t('vacancies')}
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.all_offers_from_recruiter)
            }}
          />
          <SidebarButton
            className="sidebar-button-inside w-75"
            title={t('offers_received')}
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.offers_with_talents_tm)
            }}
          />
          <SidebarButton
            className="sidebar-button-inside w-75"
            title={t('active_processes')}
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.active_processes)
            }}
          />
        </div>
      </div>

      {/* <SidebarButton
        className="sidebar-button-inside w-75"
        title={LIST_OF_DASHBOARD_OPTIONS.invite_talent}
        onClick={() => navigate(PRIVATE_ROUTES.invite_talent)}
      />
     
       <SidebarButton
        className="sidebar-button-inside w-75"
        title={LIST_OF_DASHBOARD_OPTIONS.search_talent}
        onClick={() => navigate(PRIVATE_ROUTES.talents)}
      />
      */}

      {/* <SidebarButton
        title={t('my_enterprise')}
        onClick={() => navigate(PRIVATE_ROUTES.tm_companies)}
        Icon={() => <HouseAndBuildingIcon />}
      /> */}
    </>
  )

  const CompanyRoutes = () => (
    <>
      {renderHutritNextValidation && (
        <SidebarButton
          Icon={() => <AwasomeIcon width="16" height="16" />}
          title="Superbuscador"
          className="mb-2"
          onClick={() => {
            handleCloseDrawer()
            navigate(PRIVATE_ROUTES.talents_juniors)
          }}
        />
      )}

      <SidebarButton
        Icon={() => <ProfileIcon width="16" height="16" />}
        title={t('my_profile')}
        className="mb-2"
        onClick={() => {
          handleCloseDrawer()
          navigate(PRIVATE_ROUTES.company_form)
        }}
      />

      <SidebarButton
        Icon={() => <NoteIcon fill="#E4F8ED" width="16" height="16" />}
        className="mb-2"
        title="Contrato"
        onClick={() => {
          handleCloseDrawer()
          navigate(PRIVATE_ROUTES.company_contract)
        }}
      />

      <SidebarButton
        Icon={() => <EmailCheckedIcon fill="#E4F8ED" />}
        className="mb-2"
        title="Mis facturas"
        onClick={() => {
          handleCloseDrawer()
          navigate(PRIVATE_ROUTES.company_billing)
        }}
      />

      {/* <SidebarButton
        Icon={() => <CashSmallIcon width={16} height={16} fill="#E4F8ED" />}
        className="mb-2"
        title={t('subscription')}
        onClick={() => navigate(PRIVATE_ROUTES.suscriptions)}
      /> */}
    </>
  )

  const HiringAdvisorRoutes = () => (
    <>
      <SidebarButton
        className="mb-2"
        title="Mis empresas"
        onClick={() => {
          handleCloseDrawer()
          navigate(PRIVATE_ROUTES.list_of_companies_by_hiring_advisor)
        }}
        Icon={() => (
          <HouseAndBuildingIcon width="16" height="16" fill="#E4F8ED" />
        )}
      />
      <SidebarButton
        className="mb-2"
        onClick={() => navigate('/list-of-offers')}
        title={t('offers_from_my_companies')}
        Icon={() => <SmallBriefcaseIcon width="16" height="16" />}
      />
      <SidebarButton
        Icon={() => <SearchUserIcon width="16" height="16" />}
        onClick={() => {
          handleCloseDrawer()
          navigate(PRIVATE_ROUTES.talents)
        }}
        title={t('talents')}
        className="mb-2"
      />
      <div className="dropdown">
        <div
          className="d-flex alig-items-center gap-2 sidebar-button mb-2"
          data-bs-toggle="collapse"
          href="#sidebar-collapse-hiringadvisor-juniors-section"
        >
          <SidebarButton
            Icon={() => <AwasomeIcon width="16" height="16" />}
            title={
              <div className="d-flex align-items-center gap-2">
                <div>Hutrit Club</div>
              </div>
            }
          />
        </div>
        <div
          className="collapse show"
          id="sidebar-collapse-hiringadvisor-juniors-section"
          aria-expanded="false"
        >
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Superbuscador"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.talents_juniors)
            }}
          />
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Ofertas"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.list_of_offers_juniors)
            }}
          />
        </div>
      </div>

      <SidebarButton
        className="mb-2"
        title={
          <div className="d-flex align-items-center">
            <div>Hiring Advisor AI</div>
            <Badge
              style={{
                background: '#CFF2DF',
                border: '1px solid #01A76A',
                color: '#01A76A',
                padding: '6px 8px 6px 8px',
                borderRadius: '12px',
                marginLeft: '8px',
              }}
            >
              {t('new')}
            </Badge>
          </div>
        }
        onClick={() => {
          handleCloseDrawer()
          navigate(PRIVATE_ROUTES.hiring_advisor_ai)
        }}
        Icon={() => <AwasomeIcon width="16" height="16" />}
      />
      <SidebarButton
        className="mb-2"
        title={t('my_profile')}
        onClick={() => {
          handleCloseDrawer()
          navigate(PRIVATE_ROUTES.personal_data)
        }}
        Icon={() => <ProfileIcon width="16" height="16" />}
      />
      <SidebarButton
        className="mb-2"
        title="Chat WhatsApp"
        onClick={() => {
          handleCloseDrawer()
          navigate(PRIVATE_ROUTES.chat_whatsapp)
        }}
        Icon={() => <WhatsAppChatIcon />}
      />
    </>
  )

  const AdminRoutes = () => (
    <>
      <div className="dropdown">
        <SidebarButton
          Icon={() => <SearchUserIcon width="16" height="16" />}
          title="Gestión de talentos"
          data-bs-toggle="collapse"
          href="#sidebar-collapse-admin"
          className="mb-2"
          role="button"
        />
        <div
          className="collapse"
          id="sidebar-collapse-admin"
          aria-expanded="true"
        >
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Total de talentos"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.admin_talents)
            }}
          />
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Perfiles de talentos"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.talents)
            }}
          />
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Hutrit Club"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.list_of_video_talents_master)
            }}
          />
        </div>
      </div>

      <div className="dropdown">
        <SidebarButton
          Icon={() => <HandsIcon width="16" height="16" fill="#E4F8ED" />}
          title="Talent Managers"
          data-bs-toggle="collapse"
          href="#sidebar-collapse-talents-managers-admin"
          className="mb-2"
          role="button"
        />
        <div
          className="collapse"
          id="sidebar-collapse-talents-managers-admin"
          aria-expanded="true"
        >
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Lista completa"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.admin_recruiters)
            }}
          />
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Hiring Advisors"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.list_of_hiring_advisors)
            }}
          />

        </div>
      </div>

      <div className="dropdown">
        <SidebarButton
          Icon={() => (
            <HouseAndBuildingIcon width="16" height="16" fill="#E4F8ED" />
          )}
          title="Empresas"
          data-bs-toggle="collapse"
          href="#sidebar-collapse-companies-admin"
          className="mb-2"
          role="button"
        />
        <div
          className="collapse"
          id="sidebar-collapse-companies-admin"
          aria-expanded="true"
        >
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Lista completa"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.admin_companies)
            }}
          />
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Ofertas"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.all_offers_from_recruiter)
            }}
          />
        </div>
      </div>

      <div className="dropdown">
        <SidebarButton
          Icon={() => <ConfigIcon />}
          title="Funcionalidades"
          data-bs-toggle="collapse"
          href="#sidebar-collapse-functionalities-admin"
          className="mb-2"
          role="button"
        />
        <div
          className="collapse"
          id="sidebar-collapse-functionalities-admin"
          aria-expanded="true"
        >
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Lista de habilidades"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.list_Of_Skills)
            }}
          />
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Lista de habilidades blandas"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.list_of_soft_skills)
            }}
          />
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Categorías"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.list_Of_Categories)
            }}
          />
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Sectores"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.list_Of_Sectors)
            }}
          />
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Estados"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.list_of_states)
            }}
          />
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Ciudades"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.list_of_city)
            }}
          />
          <SidebarButton
            className="sidebar-button-inside w-75"
            title="Idiomas"
            onClick={() => {
              handleCloseDrawer()
              navigate(PRIVATE_ROUTES.list_of_idioms)
            }}
          />
        </div>
      </div>
      <SidebarButton
        Icon={() => <EmailCheckedIcon fill="#E4F8ED" />}
        className="mb-2"
        title="Generador de correos"
        onClick={() => {
          handleCloseDrawer()
          navigate(PRIVATE_ROUTES.admin_send_emails)
        }}
      />
      <SidebarButton
        Icon={() => <ConfigIcon />}
        className="mb-2"
        title="Prompts personalizados"
        onClick={() => {
          handleCloseDrawer()
          navigate(PRIVATE_ROUTES.custom_prompts)
        }}
      />
      <SidebarButton
        Icon={() => <AwasomeIcon width="16" height="16" />}
        className="mb-2"
        title="Master classes"
        onClick={() => {
          handleCloseDrawer()
          navigate(PRIVATE_ROUTES.admin_master_classes)
        }}
      />
      <SidebarButton
        Icon={() => <AwasomeIcon width="16" height="16" />}
        className="mb-2"
        title="Cursos"
        onClick={() => {
          handleCloseDrawer()
          navigate(PRIVATE_ROUTES.master_courses)
        }}
      />
      <SidebarButton
        Icon={() => <ConfigIcon />}
        className="mb-2"
        title="Chat WhatsApp"
        onClick={() => {
          handleCloseDrawer()
          navigate(PRIVATE_ROUTES.whatsapp_master)
        }}
      />
    </>
  )

  const renderRoutes = {
    [TYPE_OF_USER.talent]: <TalentRoutes />,
    [TYPE_OF_USER.recruiter]: <RecruiterRoutes />,
    [TYPE_OF_USER.company]: <CompanyRoutes />,
    [TYPE_OF_USER.hiring_advisor]: <HiringAdvisorRoutes />,
    [TYPE_OF_USER.admin]: <AdminRoutes />,
  }

  return (
    <div id="sidebar-menu" className="menu-container">
      <li className="text-decoration-none menu-items-container text-white">
        <SidebarButton
          Icon={() => <HomeIcon width="16" height="16" />}
          title={t('home')}
          className="mb-2"
          onClick={() => {
            handleCloseDrawer()
            navigate(PRIVATE_ROUTES.dashboard)
          }}
        />
        {renderRoutes[typeUser]}
      </li>
    </div>
  )
}

export default Menu

//HandsIcon
